module.exports = __webpack_public_path__ + "static/media/tattle_monogram_dark.aeb40e2a.png";